import styles from './Layout.module.scss';
import { Header } from '../Header';
import { Sidebar } from 'Sidebar/Sidebar';
import { Outlet } from 'react-router-dom';
import { UserI } from '../../utils/userSlice';
import { Alert } from '../Alerts/Alerts';
import { Footer } from 'Footer/Footer';
import { SystemNotification } from '../SystemNotification';
import { UserConfiguration } from 'ais-facade-api/api';

type Props = {
  children?: React.ReactNode;
  user: UserI | null;
  withSearch?: boolean;
  uiconfig?: UserConfiguration | null;
  withFooter?: boolean;
  withHeader?: boolean;
  setInitCenter: React.Dispatch<React.SetStateAction<number[]>>;
};

export const Layout = ({ user, withSearch, uiconfig, withFooter = false, withHeader = true, setInitCenter }: Props) => {
  return (
    <>
      <SystemNotification />
      {withHeader && <Header user={user} withSearch={withSearch} setInitCenter={setInitCenter} />}
      <div className={styles.layout}>
        {user && <Sidebar uiConfig={uiconfig} />}
        <main className={styles.main} id="main">
          <Alert closable={false} />
          <Outlet />
        </main>
      </div>
      {withFooter && <Footer />}
    </>
  );
};
